import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1rem 0 10rem 0;

  & > header {
    padding: 0 1.5rem 3rem 1.5rem;
    font-family: ${({ theme }) => theme.fonts.workSans};
  }

  & > div.table-container {
    padding: 1.5rem;
    background-color: ${({ theme }) => theme.colors.gray8};
  }
`;
